<template>
  <div class="row q-pa-md">
    <q-stepper
        v-model="step"
        ref="stepper"
        color="primary"
        class="col-12"
        alternative-labels
        :contracted="$q.platform.is.mobile"
    >
      <q-step
          :name="1"
          :title="template.INTROALT"
          icon="looks_one"
          :done="step > 1"
      >
        <span v-html="rational.alternatives.content[0].html.content" ></span>
        <q-stepper-navigation>
          <q-btn class="" @click="slidenext()" color="primary" :label="template.NEXT" />
        </q-stepper-navigation>

      </q-step>

      <q-step
          :name="2"
          :title="template.ALTERNATIVES"
          icon="view_comfy"
          :done="step > 2"
      >
        <div class="text-subtitle1">{{template.CLICKITEMSEQ}}</div>
        <AlternativesDisp  :alternatives="rational.alternatives.items" @continue="slidenext()"/>
      </q-step>

      <q-step
          :name="3"
          :title="template.SORTALT"
          icon="app_registration"
          :done="step > 3"
      >
        <div class="row q-pa-md justify-center">
          <span class="col-11 text-subtitle1" v-html="template.SORTITEMSEQ" ></span>
        </div>
        <AlternativesSort  :alternatives="rational.alternatives.items" @continue="slidenext()" @form="pushFormAlt"/>

      </q-step>
      <q-step
          :name="4"
          :title="template.INTROOBJ"
          icon="palette"
          :done="step > 4"

      >
        <span v-html="rational.objectives.content[0].html.content" ></span>
        <q-stepper-navigation class="row q-pa-md q-gutter-md justify-end">
         <q-btn class="col-auto" @click="slidenext()" color="primary" :label="template.NEXT" />
        </q-stepper-navigation>
      </q-step>
               <!--      Category Obj-->

      <q-step v-for="(item,index) in getLevel0_categories" :key="index"
          :name="(5+index)"
          :title="(item.short_name!=='root')?template.OBJCAT+' '+ (index+1):template.OBJROOT"
          icon="add_comment"
          :done="step >  (5+index)"

      >
      <q-stepper
        v-model="step_children"
        color="secondary"
        class="col-12"
        header-class="hide-header"

    >
          <q-step v-for="(item2,index2) in dynamicSteps(item.short_name)" :key="index2"
          :name="index2"
          :title="item2.short_name"
          icon="add_comment"
          :done="step_children > index2">
                  <ObjectivesSort :objectives="objectivesRoot(item2.short_name)" @continue="slidenext_children(item.short_name)"
                        @form="pushFormObj(item2.short_name,$event)"
                        :firsttime="index===0&&index2===0" :rational="rational" :root="item.short_name==='root'"/>
        </q-step>
      </q-stepper>
      </q-step>
  
<!--      CONCLUSION-->
      <q-step
          :name="(5+getLevel0_categories.length)"
          :title=template.RATCONC
          icon="assessment"
          :done="step > (5+getLevel0_categories.length)"

      >
        <Conclusion_rational  @continue="onEnd()"/>
      </q-step>

      <template v-slot:navigation>
        <q-stepper-navigation>
        </q-stepper-navigation>
      </template>
    </q-stepper>
  </div>
</template>

<script>
import AlternativesDisp from "@/components/AlternativesDisp";
import AlternativesSort from "@/components/AlternativesSort";
import ObjectivesSort from "@/components/ObjectivesSort";
import Conclusion_rational from "@/components/Conclusion_rational";

export default {
name: "RationalSurvey",
  components: {Conclusion_rational, AlternativesSort, AlternativesDisp,ObjectivesSort},
  data(){return{
    loaded:["templatetrans","rational","info"],
    form:{},
    step:1,
    step_children: 0,
  }  },
  computed:{
    objectivesRoot() {
      return shortName => {
        if (!shortName) return []
        const orig = this.getObjectives(shortName)
        if (!orig) return null
        // shallow-clone so we don’t mutate the source
        const item = { ...orig, children: Array.isArray(orig.children) ? orig.children.slice() : [] }
        const prevRoot = this.root_objs.filter(r => r.parent_short_name === shortName)
        prevRoot.forEach(childShort => {
            const childItem = this.getObjectives(childShort.root_objective)
            if (childItem) item.children.push(childItem)
          })
        // filter children to only include those of type 'objective'
        item.children = item.children.filter(c => c.type === 'objective')
        return item
    }
  },

    root_objs:function(){
      let root_objs = [];
      if(!this.form.objectives) return [];
      Object.keys(this.form.objectives).forEach(key => {
        const item = this.form.objectives[key];
        if (!item || !item.rootobj) return; // Skip if no rootobj
          const rootObj = this.getParentShortName(key) || 'root';
          if(rootObj) root_objs.push({parent_short_name:rootObj ,root_objective:item.rootobj});
      });
      return root_objs;
    },

    getLevel0_categories() {
      let steps = this.rational.objectives.items.filter(item => item.type === 'category' && item.children && item.children.length > 0);
      // Add root step
      steps.push({short_name:"root"});
      return steps;
    },
    
    redirect:function(){
      let info = this.$store.getters['csurvey/getdata']('info')
      return (info.externalurl.enableexiturl && info.externalurl.pointofexit==="rational")
    },
    template: function(){return this.$store.getters['csurvey/getdata']('templatetrans')||{}},
    rational:function(){return this.$store.getters['csurvey/getdata']('rational')||
        {alternatives:
          {content:[{html:{content:null}}]},
          objectives:{content:[{html:{content:null}}]},
        general:{learnloop:true}
        }
          },

  },
  methods:{
    dynamicSteps(short_name) {
      const steps = [];
      let root = this.getObjectives(short_name) || [];
      root = Array.isArray(root) ? root : [root];

      const traverse = (nodes, parentShort = null) => {
        // only consider siblings of type 'category'
        const siblings = nodes.filter(n => n.type === 'category');
        siblings.forEach((node) => {
          const hasChildren = Array.isArray(node.children) && node.children.length > 0;
          if (hasChildren) {
            // first descend into children
            traverse(node.children, node.short_name);
          }
          // then push the node itself
          steps.push({
            short_name: node.short_name,
            parent_short_name: parentShort,
            
          });
        });
      };
      traverse(root, null);
      return steps;
    },
    getObjectives(short_name) {
        return this.$store.getters['csurvey/getObjectives'](short_name) || null;
    },  
    getParentShortName(short_name) {
        return this.$store.getters['csurvey/getObjectiveParentShortName'](short_name) || null;
    },
    getAllObjectiveShortNames() {
        return this.$store.getters['csurvey/getObjectivesShortnames'] || [];
    },
    async onEnd(){
        if(this.redirect) {
          await this.$store.dispatch('cauth/setUserStatus','finished');
          this.$router.push({name: "redirecturl"})
        } else {
          this.$router.push({name: "postsurvey",params: { id: 0 }})
        }
      },
    pushFormAlt(value){
        this.form.alternatives.push(value)
        this.$set(this.form,'step',this.step);
        this.$store.dispatch("csurvey/setUserInput",{field:'rational',value:JSON.parse(JSON.stringify(this.form))})
    },
    pushFormObj(obj,value){
      this.$set(this.form.objectives, obj, value);
      this.$set(this.form,'step',this.step);
      this.$set(this.form.objectives,'step_children',this.step_children);
      this.$store.dispatch("csurvey/setUserInput",{field:'rational',value:JSON.parse(JSON.stringify(this.form))});
    },
    slidenext(){
      this.$refs.stepper.next();
      window.scrollTo(0, 0);
    },
    slidenext_children(short_name){
      if (this.step_children < this.dynamicSteps(short_name).length - 1) {
        this.step_children++;
      } else {
        this.step_children = 0;
        this.step++;
      }
      window.scrollTo(0, 0);
    }
  },
  async created(){
    this.$q.loading.show({
      message: 'Loading data <br/><span class="text-primary">Hang on...</span>'
    });
    for (const field of this.loaded) {
      await this.$store.dispatch('csurvey/loadkey', field);
    }
    this.$q.loading.hide();
    this.form=JSON.parse(JSON.stringify(this.$store.getters['csurvey/getuserinput']('rational')));
    if(!this.form.alternatives) this.$set(this.form,'alternatives',[]);
    if(!this.form.objectives) this.$set(this.form,'objectives',{});
  },
  mounted(){
        if (this.form.step) this.step=this.form.step;
        if (this.form.objectives&&this.form.objectives.step_children) this.step_children=this.form.objectives.step_children;
  },
  watch: { // Send step modification to database
    step: {
      handler: function (newValue) {
        this.form.step=newValue
        this.$store.dispatch("csurvey/setUserInput",{field:'rational',value:JSON.parse(JSON.stringify(this.form))})
      }
    }
  },
}
</script>

<style >
.hide-header {
  display: none;
}
</style>
